// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__15lxj","ranges":"BmiRanges_ranges__1xQMM"};